var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","color":"white"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._t("default")],2)]}}],null,true)},[_c('div',{staticStyle:{"color":"#000","font-size":"16px"}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }